import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EmailVerify, mapping } from './email-verify.model';
import { AuthService } from '../auth.service';


@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrls: ['./email-verify.component.sass']
})
export class EmailVerifyComponent implements OnInit {

  isError: boolean = true;
  isSpinning: boolean = true;
  token: string;
  emailElements: EmailVerify = new EmailVerify("", "");

  constructor(private route: ActivatedRoute, private authService: AuthService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.token = params.get("token")
      this.verify(this.token);
    })
  }

  verify(token: string) {
    let errorCode: string;
    this.isSpinning = true;
    this.authService.verifyEmail(token)
      .subscribe(
        data => {
          this.isError = data.esito.toLowerCase() === "ko";
          this.emailElements = mapping["defaultError"];
          if ( this.isError ) {
            errorCode = data.result.error_code;
            if(errorCode !== "E037") {
              if(errorCode in mapping)
              {
                this.emailElements = mapping[errorCode];
              }
              this.isSpinning = false;
            } else {
              this.authService.resendConfirmationEmail(token)
                .subscribe(
                  data => {
                    this.isError = data.esito.toLowerCase() === "ko";
                    if( !this.isError){
                      this.emailElements = mapping[errorCode];
                    }
                    this.isSpinning = false;
                  }, _ => {
                    this.isSpinning = false;
                    this.isError = true;
                  }
                )
            }
          }
          else {
            this.emailElements = mapping["defaultSuccess"]
            this.isSpinning = false;
          }
        }, _ => {
          this.isSpinning = false;
          this.isError = true
        }
      )
  }

}
